"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LayoutContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The default Layout-Component. Can be used with Both LayoutItem inside as well as other components.
 * Is very flexible. You can use some predefined grids with the grid-prop or you can use variants.
 * The default instance without props just add vertical spacing between items
 *
 */
var Layout = function Layout(_ref) {
  var grid = _ref.grid,
      children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      columnGap = _ref.columnGap,
      rowGap = _ref.rowGap,
      paddingTop = _ref.paddingTop,
      paddingBottom = _ref.paddingBottom,
      restProps = _objectWithoutProperties(_ref, ["grid", "children", "className", "variant", "columnGap", "rowGap", "paddingTop", "paddingBottom"]);

  return _react["default"].createElement(LayoutContainer, _extends({
    className: className,
    grid: grid,
    variant: variant,
    columnGap: columnGap,
    rowGap: rowGap,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom
  }, restProps), children);
};

Layout.themeProps = {
  container: {
    name: "LAYOUT",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var isNotFlush = function isNotFlush(space) {
  switch (space) {
    case "flush":
      return false;

    default:
      return true;
  }
};

var LayoutContainer = _styledComponents["default"].div.withConfig({
  displayName: "Layout__LayoutContainer",
  componentId: "sc-12420of-0"
})(["display:grid;", ";", ";", ";", ";", ";", ";"], function (p) {
  return isNotFlush(p.rowGap) && (0, _styledComponents.css)(["grid-row-gap:", ";"], (0, _theming.spacing)(p.rowGap));
}, function (p) {
  return isNotFlush(p.columnGap) && (0, _styledComponents.css)(["grid-column-gap:", ";"], (0, _theming.spacing)(p.columnGap));
}, function (p) {
  return isNotFlush(p.paddingBottom) && (0, _styledComponents.css)(["padding-bottom:", ";"], (0, _theming.spacing)(p.paddingBottom));
}, function (p) {
  return isNotFlush(p.paddingTop) && (0, _styledComponents.css)(["padding-top:", ";"], (0, _theming.spacing)(p.paddingTop));
}, function (p) {
  return p.grid && _theming.grid;
}, (0, _theming.applyVariants)(Layout.themeProps.container));

exports.LayoutContainer = LayoutContainer;
Layout.defaultProps = {
  className: "",
  grid: null,
  columnGap: "medium",
  rowGap: "medium",
  paddingBottom: "flush",
  paddingTop: "flush"
};
Layout.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string,
  grid: _propTypes["default"].string,
  columnGap: _propTypes["default"].string,
  rowGap: _propTypes["default"].string,
  paddingBottom: _propTypes["default"].string,
  paddingTop: _propTypes["default"].string
};
var _default = Layout;
exports["default"] = _default;